
import { DeleteIcon, IconButton, MuiTooltip } from '@common';

const CommonDeleteButton = ({ handleClick, removePadding = false, permission = true, title = "Delete", sx = {} }) => {
    if (!permission) return null;
    return (
        <MuiTooltip title={title}>
            <IconButton
                onClick={handleClick}
                sx={{
                    ...(removePadding && {
                        padding: 0
                    })
                }}
            >
                <DeleteIcon
                    color="red"
                    sx={{
                        cursor: "pointer",
                        color: "red",
                        ...sx,
                    }}
                />
            </IconButton>
        </MuiTooltip>
    )
}
export default CommonDeleteButton